import axios from '@/libs/api.request'
import fileAxios from '@/libs/file.request'
// 活动列表
export const apiActivitiesList = data => {
  return axios.request({
    url: '/admin/activities',
    method: 'get',
    data,
  })
}
// 活动详情
export const apiActivitiesDetail = (id,data) => {
  return axios.request({
    url: `/admin/activities/${id}`,
    method: 'get',
    data,
  })
}
// 新增活动
export const apiActivitiesAdd = data => {
  return axios.request({
    url: '/admin/activities',
    method: 'post',
    data,
  })
}
// 编辑活动
export const apiActivitiesEdit = (id,data) => {
  return axios.request({
    url: `/admin/activities/${id}`,
    method: 'put',
    data,
  })
}
// 删除活动
export const apiActivitiesDetele = (id,data) => {
  return axios.request({
    url: `/admin/activities/${id}`,
    method: 'delete',
    data,
  })
}
// 报名列表
export const apiActivitiesSignList = (data) => {
  return axios.request({
    url: `/admin/activities-registrations`,
    method: 'get',
    data,
  })
}
// 报名详情
export const apiActivitiesSignDetail = (id,data) => {
  return axios.request({
    url: `/admin/activities-registrations/${id}`,
    method: 'get',
    data,
  })
}
// 修改报名
export const apiActivitiesSignEdit = (id,data) => {
  return axios.request({
    url: `/admin/activities-registrations/${id}`,
    method: 'put',
    data,
  })
}
// 审核
export const apiActivitiesExamine = (id,data) => {
  return axios.request({
    url: `/admin/activities-registrations/examine/${id}`,
    method: 'put',
    data,
  })
}
// 导出单个报名
export const apiActivitiesExportSingle = (id,data) => {
  return fileAxios.request({
    url: `/admin/activities-registrations/leading-out/${id}`,
    method: 'get',
    data,
  })
}
// 导出全部报名
export const apiActivitiesExportAll = (id,data) => {
  return fileAxios.request({
    url: `/admin/activities/leading-out/${id}`,
    method: 'get',
    data,
  })
}